<script>
import { PodcastCategory } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Podcast Category List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Podtytuł',
            modelPath: [this, 'form', 'subtitle'],
            multilingual: true,
            required: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return PodcastCategory
    }
  }
}
</script>
